import React from 'react';
import ScrollToTop from '../../atoms/scrollToTop';
import CheckListPopupContainer from "../../organisms/common/checkListPopupContainer";
import CrawlSenyuubiPopupContainer from '../../organisms/common/crawlSenyuubiPopupContainer';
import { HeaderContainer } from '../../organisms/common/headerContainer';
import MembershipCancelPopup from '../../organisms/common/membershipCancelPopup';
import MembershipPopupContainer from '../../organisms/common/membershipPopupContainer';
import MembershipReservationPopupContainer from '../../organisms/common/membershipReservationPopupContainer';
import CheckCalendarContainer from '../../organisms/hotel/checkCalendarContainer';
import MembershipSearchResultContainer from '../../organisms/hotel/membershipSearchResultContainer';
import { DescriptionHomeFlContainer } from '../../organisms/common/descriptionHomeFlContainer';

class MembershipSearchResultTemplate extends React.Component {

    render() {
        return (
            <>
                <ScrollToTop />
                <HeaderContainer
                    state={this.props.state}
                    Label categoryLabel1={"検索結果"}
                    categoryLabel2={"RESULT"}
                    path={this.props.state.loginType === "MEMBER" ? "/reserve/hotel/search" : "/reserve/hotel/crawlSearch"}
                    bookedConfirmLabel={"＞予約内容の確認・変更・キャンセルはこちら"}
                    onClickOpenReservationPopupWindow={this.props.onClickOpenReservationConfPopupWindow}
                    onClickOpenSenyuubiWindow={this.props.onClickOpenSenyuubiWindow}
                    tabIndex="19" />
                <MembershipPopupContainer
                    state={this.props.state}
                    setPopupMode={this.props.setPopupMode}
                    setPopupMessage={this.props.setPopupMessage}
                    onClickClosePopupWindow={this.props.onClickClosePopupWindow}
                    onClickCountWindow={this.props.onClickCountWindow}
                    createAgeCountList={this.props.createAgeCountList} />
                <CheckListPopupContainer
                    state={this.props.state}
                    onClickOpenCheckListWindow={this.props.onClickOpenCheckListWindow} />
                <CheckCalendarContainer
                    state={this.props.state}
                    onClickOpenCalendarWindow={this.props.onClickOpenCalendarWindow}
                    checkInFlg={this.props.state.checkInFlg}
                    checkOutFlg={this.props.state.checkOutFlg} />
                <MembershipSearchResultContainer
                    state={this.props.state}
                    onClickOpenCheckListWindow={this.props.onClickOpenCheckListWindow}
                    onClickOpenCalendarWindow={this.props.onClickOpenCalendarWindow}
                    onClickOpenReservationPopupWindow={this.props.onClickOpenReservationPopupWindow}
                    setPopupData={this.props.setPopupData}
                    setPopupMessage={this.props.setPopupMessage}
                    setBeforeAreaId={this.props.setBeforeAreaId}
                    setBeforeCountryId={this.props.setBeforeCountryId}
                    setLoginType={this.props.setLoginType}
                    setSelectKeiyakuNo={this.props.setSelectKeiyakuNo}
                    setOpenFacilityFlg={this.props.setOpenFacilityFlg}
                    createAgeCountList={this.props.createAgeCountList}
                />
                <CrawlSenyuubiPopupContainer
                    state={this.props.state}
                    onClickOpenDescriptionHomeFlWindow={this.props.onClickOpenDescriptionHomeFlWindow}
                    onClickCloseSenyuubiPopupWindow={this.props.onClickCloseSenyuubiPopupWindow}
                />
                <DescriptionHomeFlContainer
                    state={this.props.state}
                    onClickCloseDescriptionHomeFlWindow={this.props.onClickCloseDescriptionHomeFlWindow}
                />
                <MembershipReservationPopupContainer
                    state={this.props.state}
                    onClickClosePopupWindow={this.props.onClickCloseReservationConfPopupWindow}
                    onClickOpenCancelPopupWindow={this.props.onClickOpenCancelPopupWindow}
                />
                <MembershipCancelPopup
                    state={this.props.state}
                    onClickCloseCancelPopupWindow={this.props.onClickCloseCancelPopupWindow}
                />
            </>
        )
    }
}
export default MembershipSearchResultTemplate;
